export const PlanType: PlanTypes[] = [
  {key: 'Family', value: 'FAMILY'},
  {key: 'Individual', value: 'IND'},
  {key: 'Ind w/Child', value: 'INDCH'},
];

export const CriticalIllnessPlanType: PlanTypes[] = [
  {key: 'Individual', value: 'IND'},
  {key: 'Family', value: 'FAMILY'},
  {key: 'Individual w/Spouse', value: 'INDSPS'},
  {key: 'Ind w/Child', value: 'INDCH'},
];
export const CriticalIllnessNYPlanType: PlanTypes[] = [
  {key: 'Family', value: 'FAMILY'},
  {key: 'Individual', value: 'IND'},
  {key: 'Ind w/Child', value: 'INDCH'},
];
export type PlanTypes = {
  key: string;
  value: string;
};
